var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Button, DataTable, Page, Tag, Timestamp, } from '@dixa/lib-shared-habla';
import { config } from 'lib-shared-backend-config';
import { authApi } from 'apis/auth';
import { appActions } from 'app/app.actions';
import { analytics } from 'app/utils/segment';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { SettingsIntegrationsDocumentationButton } from '../../components/documentationButton/documentationButton';
import { ApiTokensTableActions } from './components/tableActions/apiTokensTableActions';
import { apiTokenTypesByVersion } from './utils/tokenType';
export const pathToApiTokensSettings = '/settings/integrations/api-tokens';
const emptyArray = [];
/** Settings page that lists all API tokens. */
export const SettingsIntegrationsApiTokensView = () => {
    const navigate = useAppNavigate();
    const dispatch = useAppDispatch();
    const notify = useNotifications();
    const { tokens, isLoading, isError, isSuccess, refetch } = authApi.useReadApiTokensQuery(undefined, {
        selectFromResult: (_a) => {
            var { data } = _a, rest = __rest(_a, ["data"]);
            return (Object.assign(Object.assign({}, rest), { tokens: (data === null || data === void 0 ? void 0 : data.data.tokens) || emptyArray }));
        },
    });
    const [deleteApitoken] = authApi.useDeleteApiTokenMutation();
    const handleDeleteApiToken = ({ id, name, }) => __awaiter(void 0, void 0, void 0, function* () {
        const { isConfirmed } = yield dispatch(appActions.showModal({
            modal: {
                type: 'app:confirm',
                arg: {
                    title: `Delete "${name}"`,
                    description: 'Are you sure you want to delete this API token?',
                    confirm: {
                        label: 'Delete',
                    },
                },
            },
        }));
        if (isConfirmed) {
            try {
                yield deleteApitoken({ tokenId: id });
                notify({
                    title: 'Success',
                    text: `"${name}" has been deleted.`,
                    icon: 'i-done',
                    time: 5000,
                }, NotificationType.Success);
            }
            catch (error) {
                notify({ title: `Error while deleting "${name}".` }, NotificationType.Error);
            }
        }
    });
    return (_jsx(Page.Section, Object.assign({ title: "All API tokens", titleMeta: _jsxs(_Fragment, { children: [tokens.length > 0 && (_jsx(Badge, Object.assign({ size: "small", variant: "secondary" }, { children: tokens.length }))), _jsx(SettingsIntegrationsDocumentationButton, { onClick: () => {
                        analytics.settingsIntegrationsApiTokensDocumentationLinkIntegrationsApi();
                        window.open(`https://${config.domain.integrations}/openapi`, '_blank', 'noopener,noreferrer');
                    } })] }), controls: _jsx(Button, Object.assign({ onClick: () => navigate({
                path: `${pathToApiTokensSettings}/create`,
            }) }, { children: "Add API token" })) }, { children: _jsx(DataTable, { data: tokens, tableStyleProps: {
                stickyHeader: true,
            }, tableStatusProps: {
                loading: isLoading,
                loadingFailed: isError,
                onLoadingRetry: refetch,
                emptyState: !tokens.length && isSuccess
                    ? {
                        title: 'Nothing to show here',
                        description: 'No API tokens created yet',
                    }
                    : undefined,
            }, columns: [
                {
                    label: 'Name',
                    selector: ({ name }) => name,
                },
                {
                    label: 'Version',
                    selector: ({ version }) => {
                        if (version) {
                            const tokenType = apiTokenTypesByVersion[version];
                            return _jsx(Tag, Object.assign({ color: tokenType.color }, { children: tokenType.label }));
                        }
                    },
                },
                {
                    label: 'Created',
                    selector: ({ created_at }) => _jsx(Timestamp, { time: created_at }),
                },
                {
                    label: undefined,
                    style: {
                        width: 0,
                    },
                    selector: ({ id, name, value }) => (_jsx(ApiTokensTableActions, { id: id, name: name, token: value, handleDeleteApiToken: handleDeleteApiToken })),
                },
            ] }) })));
};
